import styled from "styled-components";

interface TermStyleProps {
  $processBar?: boolean;
}

export const TermBox = styled.div`
  gap: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Term = styled.div<TermStyleProps>`
  border: 1px solid ${(props) => props.theme.colors.inputBg};
  padding: 16px;
  overflow: hidden;
  background: ${(props) => props.theme.colors.white100};
  max-height: ${(props) =>
    props.$processBar ? "calc(100vh - 430px)" : "calc(100vh - 380px)"};
  border-radius: 10px;

  p {
    height: 100%;
    padding: 10px;
    overflow: auto;
    font-size: 1.2rem;
    line-height: 160%;
  }

  span {
    color: ${(props) => props.theme.colors.bright100};
  }

  .img_example {
    gap: 4px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    img {
      width: 100%;
      object-fit: contain;
      object-position: center;
    }

    b {
      color: ${(props) => props.theme.colors.primary100};
      font-size: 1.3rem;
    }
  }
`;

export const TermAgree = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  background: ${(props) => props.theme.colors.white100};
  box-shadow: ${(props) => props.theme.shadows.button};
  align-items: center;
  border-radius: 6px;

  &:has(input:checked) {
    border: 1px solid ${(props) => props.theme.colors.primary100};
    box-shadow: none;

    label {
      color: ${(props) => props.theme.colors.black80};
    }
  }

  & > div {
    width: 100%;

    label {
      width: 100%;
      padding: 6px 16px;
    }
  }
`;
